"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleExtensionDefinition = void 0;
const WidgetExtensionPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPlugin");
const WidgetExtensionPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPluginDefinition");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const WidgetError_1 = require("auto-widget-framework/src/Error/WidgetError");
class CollapsibleExtension extends WidgetExtensionPlugin_1.default {
    /**
     * @inheritDoc
     */
    initialize(widget) {
        this.widget = widget;
        this.widget.getEventContainer().on(WidgetEvents_1.WidgetEvents.STEP_READY, this.registerCollapsible.bind(this));
        return Promise.resolve();
    }
    registerCollapsible() {
        let container = document.getElementById(this.widget.getConfig().getContainerId());
        if (!container) {
            throw new WidgetError_1.default('Failed registering collapsibles.');
        }
        let collapsibleElements = container.querySelectorAll(".px-collapsible");
        Array.from(collapsibleElements).forEach((col) => {
            col.addEventListener("click", () => this.toggleCollapsible(col));
            if (col.checked) {
                this.toggleCollapsible(col);
            }
        });
    }
    toggleCollapsible(element) {
        element.classList.toggle("active");
        let content = element.nextElementSibling;
        content.classList.toggle("active");
        if (content.style.display === "block") {
            content.style.display = "none";
        }
        else {
            content.style.display = "block";
        }
    }
}
exports.default = CollapsibleExtension;
exports.CollapsibleExtensionDefinition = new WidgetExtensionPluginDefinition_1.default({
    id: "collapsible",
    class: CollapsibleExtension
});
